export enum SearchTypeEnum {
  "all" = "",
  "private" = "available:false",
  "public" = "available:true"
}
